import { Component, OnInit, HostListener, Input, ViewChild, ElementRef, EventEmitter, Output, Renderer2 } from '@angular/core';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import { CarouselInfo } from 'app/model/carousel.model';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'act-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit {
  public index = 0;
  public posX1 = 0;
  public posX2 = 0;
  public posInitial = 0;
  public posFinal = 0;
  public threshold = 0;
  public itemSize = 0;
  public isClick = false;
  public isMobile = false;
  public allowShift: boolean;
  public interVal = null;
  public carouselItem: HTMLCollection;
  public carouselItemLength: number;
  public carouselItemSize: number;
  public containerItems: HTMLElement;
  public images: string[];
  public mobileImages: string[];
  public MAX_IMAGE_LENGTH: number;
  private langSubscription: Subscription;

  @Input() data: CarouselInfo;
  @Input() isModalOpen: boolean;
  @Output() eventIndex = new EventEmitter<number>();
  @ViewChild('wrapper') wrapper: ElementRef;
  @ViewChild('container') container: ElementRef;

  constructor(
    private renderer: Renderer2,
    private appConfigService: AppConfigService,
    private utilitiesService: UtilitiesService) {
  }

  ngOnInit() {
    this.utilitiesService.isScreenLessThan416() && (this.isMobile = true);
    this.MAX_IMAGE_LENGTH = this.data.imagesTh.length;
    this.setImageLang(this.appConfigService.getLanguage());
    this.langSubscription = this.appConfigService.getLanguageObs().subscribe((lang) => {
      this.setImageLang(lang);
    });
  }
  
  ngAfterViewInit() {
    //Binding and Add listener first
    this.containerItems = this.wrapper.nativeElement;
    this.carouselItem = this.containerItems.children;
    this.setDefaultValue();
    this.setAutoSlide();
    this.renderer.listen(this.containerItems, 'mouseenter', this.removeAutoSlide.bind(this));
    this.renderer.listen(this.containerItems, 'mouseleave', this.setAutoSlide.bind(this));
    this.renderer.listen(this.containerItems, 'touchstart', this.utilitiesService.debounce(this.ontouchstart.bind(this), 350));
    this.renderer.listen(this.containerItems, 'touchmove', this.utilitiesService.debounce(this.ontouchmove.bind(this), 350));
    this.renderer.listen(this.containerItems, 'touchend', this.utilitiesService.debounce(this.ontouchend.bind(this), 350));
    this.renderer.listen(this.containerItems, 'transitionend', this.checkIndex.bind(this));
  }

  ngOnDestroy() {
    this.langSubscription && this.langSubscription.unsubscribe();
  }

  setImageLang(lang: string) {
    if (lang === 'th') {
      this.images = this.data.imagesTh;
      this.mobileImages = this.data.mobileImagesTh;
    } else {
      this.images = this.data.imagesEn;
      this.mobileImages = this.data.mobileImagesEn;
    }
  }

  setAutoSlide() {
    if(this.interVal){
      clearInterval(this.interVal);
    }
    this.interVal = setInterval(this.moveSlide.bind(this, 1), 7000);
  }

  removeAutoSlide() {
    clearInterval(this.interVal);
  }

  handleEvent(index: number) {
    if(!this.isModalOpen){
      this.eventIndex.emit(index);
    }
  }

  setDefaultValue() {
    this.posX1 = 0;
    this.posX2 = 0;
    this.posInitial = 0;
    this.posFinal = 0;
    this.threshold = 100;
    this.carouselItemLength = this.MAX_IMAGE_LENGTH;
    this.carouselItemSize = this.carouselItem[0].clientWidth;
    this.allowShift = true;
    this.renderer.setStyle(this.containerItems, 'left', (this.posInitial - this.carouselItemSize * (this.index + 1)) + 'px');
  }

  setImageDisplay(targetIndex: number) {
    let hop = targetIndex - this.index;
    if (hop > 0) {
      this.shiftSlide('right', null, hop);
    } else if (hop < 0) {
      this.shiftSlide('left', null, Math.abs(hop))
    }
  }

  moveSlide(value:number) {
    this.removeAutoSlide();
    if(value > 0) {
      this.shiftSlide('right', null);
    } else {
      this.shiftSlide('left', null);
    }
    this.setAutoSlide();
  };

  shiftSlide(direction: string, action: string, hop = 1) {
    let carouselItemSize = this.carouselItem[0].clientWidth;
    this.renderer.addClass(this.containerItems, 'shifting');
    if (this.allowShift) {
      if (!action) {
        this.posInitial = this.containerItems.offsetLeft;
      }
      if (direction === 'right') {
        this.renderer.setStyle(this.containerItems, 'left', (this.posInitial - (carouselItemSize * hop)) + 'px');
        this.index = this.index + (1 * hop);
      } else if (direction === 'left') {
        this.renderer.setStyle(this.containerItems, 'left', (this.posInitial + (carouselItemSize * hop)) + 'px');
        this.index = this.index - (1 * hop);
      }
    }
    this.allowShift = false;
  }

  checkIndex() {
    this.renderer.removeClass(this.containerItems, 'shifting');
    if (this.index < 0) {
      this.renderer.setStyle(this.containerItems, 'left', -(this.carouselItemLength * this.carouselItemSize) + 'px');
      this.index = this.carouselItemLength - 1;
    }
    if (this.index >= this.data.imagesTh.length) {
      this.renderer.setStyle(this.containerItems, 'left',  -(1 * this.carouselItemSize) + 'px');
      this.index = 0;
    }
    this.allowShift = true;
  }

  ontouchstart(event) {
    this.removeAutoSlide();
    this.isClick = true;
    this.posInitial = this.containerItems.offsetLeft;
    this.posX1 = event.touches[0].clientX;
  }

  ontouchmove(event) {
    event.preventDefault();
    this.isClick = false;
    this.posX2 = this.posX1 - event.touches[0].clientX;
    this.posX1 = event.touches[0].clientX;
    this.renderer.setStyle(this.containerItems, 'left',  (this.containerItems.offsetLeft - this.posX2) + 'px');
  }

  ontouchend() {
    this.setAutoSlide();
    this.posFinal = this.containerItems.offsetLeft;
    if (this.posFinal - this.posInitial < - this.threshold) {
      this.shiftSlide('right', 'drag');
    } else if (this.posFinal - this.posInitial > this.threshold) {
      this.shiftSlide('left', 'drag');
    } else {
      this.renderer.setStyle(this.containerItems, 'left',  (this.posInitial) + 'px');
    }
    if (this.isClick) {
      this.handleEvent(this.index);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.removeAutoSlide();
    this.isMobile = this.utilitiesService.isScreenLessThan416();
    this.setDefaultValue();
    this.setAutoSlide();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/carousel/carousel.component.ts